import * as React from "react";
import * as _ from "underscore";
import classnames from "classnames";
import Select from "react-select";

import { EMDASH } from "@eave/shared/utils/general";

const styles = require("./styles.module.scss");

/* helpers */

const OriginalValue: React.SFC<any> = ({ val, editing, onDoubleClick }) => {
  const classes = classnames({
    [styles.editVal__original]: !editing,
  });

  return (
    <div onDoubleClick={onDoubleClick} className={classes}>
      {val === null ? EMDASH : val}
    </div>
  );
};

/* main */

const initProps = () => ({
  editing: false,
});

interface IProps {
  value: any;
  selectOpts: any;
  searchable: boolean;
  onUpdate: Function;
  formatting?: Function;
}

class EditableSelectValue extends React.Component<IProps, any> {
  constructor(props) {
    super(props);
    this.state = initProps();

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps() {
    this.setState(initProps());
  }

  toggleEditing(editing: boolean) {
    this.setState({
      ...this.state,
      editing,
    });
  }

  onChange(e) {
    this.toggleEditing(false);
    this.props.onUpdate(e.value);
  }

  render() {
    const { value, selectOpts, searchable, formatting } = this.props;
    const { editing } = this.state;

    let val = value;
    if (formatting) {
      val = formatting(value);
    }

    return (
      <div className={styles.editVal__container}>
        {editing ? (
          <div className={styles.editVal__select}>
            <Select
              autoFocus
              openOnFocus
              clearable={false}
              value={value}
              options={_.reject(selectOpts, (o: any) => o.value === value)}
              searchable={searchable}
              onChange={this.onChange}
              onClose={() => this.toggleEditing(false)}
            />
          </div>
        ) : (
          <OriginalValue
            onDoubleClick={() => this.toggleEditing(true)}
            val={val}
            editing={editing}
          />
        )}
      </div>
    );
  }
}

export default EditableSelectValue;
